module.exports = __webpack_public_path__ + "static/media/profile-delete.a74d48f2.svg";